module.exports = __webpack_public_path__ + "img/yt-qiavax_usdc.e051b91e.png";